/*
==============================================================================
MANTRAROMA CUSTOM

Datei:
assets/mantraroma-heart-action-overlay.js

Version: 1.4.0
Datum: 12.07.2026

Zweck:
- Öffnet und schließt die Infokarte der Herzaktion.
- Zeigt ohne Herzartikel „💜 Herzaktion“.
- Zeigt ab einem Herzartikel fünf Fortschrittsherzen.
- Verwendet 🤍 für freie und 💜 für erreichte Herzen.
- Bezieht den aktuellen Warenkorbstatus aus der zentralen
  Mantraroma-Rabattfortschrittslogik.
==============================================================================
*/

(() => {
  const SELECTORS = {
    container: '[data-mantraroma-heart-action]',
    toggle: '[data-mantraroma-heart-action-toggle]',
    panel: '[data-mantraroma-heart-action-panel]',
    close: '[data-mantraroma-heart-action-close]',
    mainHeart: '[data-mantraroma-heart-action-main-heart]',
    label: '[data-mantraroma-heart-action-label]',
    heartsContainer: '[data-mantraroma-heart-action-hearts]',
    heart: '.mantraroma-heart-action__heart'
  };

  function updateHeartDisplay(container, quantity) {
    if (!container) {
      return;
    }

    const mainHeart = container.querySelector(
      SELECTORS.mainHeart
    );

    const label = container.querySelector(
      SELECTORS.label
    );

    const heartsContainer = container.querySelector(
      SELECTORS.heartsContainer
    );

    const hearts = container.querySelectorAll(
      SELECTORS.heart
    );

    let discountQuantity = Number(quantity) || 0;

    if (discountQuantity < 0) {
      discountQuantity = 0;
    }

    const displayedQuantity = Math.min(
      discountQuantity,
      5
    );

    container.dataset.mantraromaDiscountCount =
      String(discountQuantity);

    if (mainHeart) {
      mainHeart.hidden = discountQuantity > 0;
    }

    if (label) {
      label.hidden = discountQuantity > 0;
    }

    if (heartsContainer) {
      heartsContainer.hidden = discountQuantity === 0;

      heartsContainer.setAttribute(
        'aria-label',
        `${discountQuantity} von 5 Herzartikeln im Warenkorb`
      );
    }

    hearts.forEach((heart, index) => {
      heart.textContent =
        index < displayedQuantity ? '💜' : '🤍';
    });
  }

  function updateAllHeartDisplays(quantity) {
    document
      .querySelectorAll(SELECTORS.container)
      .forEach((container) => {
        updateHeartDisplay(container, quantity);
      });
  }

  function initialiseHeartAction(container) {
    if (
      !container ||
      container.dataset.mantraromaInitialised === 'true'
    ) {
      return;
    }

    const toggle = container.querySelector(
      SELECTORS.toggle
    );

    const panel = container.querySelector(
      SELECTORS.panel
    );

    const close = container.querySelector(
      SELECTORS.close
    );

    if (!toggle || !panel) {
      return;
    }

    container.dataset.mantraromaInitialised = 'true';

    function openPanel() {
      panel.hidden = false;

      toggle.setAttribute(
        'aria-expanded',
        'true'
      );

      container.classList.add('is-open');
    }

    function closePanel() {
      panel.hidden = true;

      toggle.setAttribute(
        'aria-expanded',
        'false'
      );

      container.classList.remove('is-open');
    }

    toggle.addEventListener('click', () => {
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    });

    if (close) {
      close.addEventListener(
        'click',
        closePanel
      );
    }

    document.addEventListener('click', (event) => {
      if (
        !panel.hidden &&
        !container.contains(event.target)
      ) {
        closePanel();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (
        event.key === 'Escape' &&
        !panel.hidden
      ) {
        closePanel();
        toggle.focus();
      }
    });

    const initialQuantity = Number(
      container.dataset.mantraromaDiscountCount
    ) || 0;

    updateHeartDisplay(
      container,
      initialQuantity
    );
  }

  function initialise() {
    document
      .querySelectorAll(SELECTORS.container)
      .forEach(initialiseHeartAction);
  }

  /*
   * Wird von assets/mantraroma-discount-progress.js
   * nach jeder Aktualisierung des Rabattstatus ausgelöst.
   */
  document.addEventListener(
    'mantraroma:discount-state-updated',
    (event) => {
      const quantity =
        Number(event.detail?.quantity) || 0;

      updateAllHeartDisplays(quantity);
    }
  );

  document.addEventListener(
    'shopify:section:load',
    initialise
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialise
    );
  } else {
    initialise();
  }
})();